import {
  GetProductsByIdsQuery,
  GetActivityProductsQuery,
} from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'

type Products =
  | GetProductsByIdsQuery['products']
  | NonNullable<GetActivityProductsQuery['activity']>['products']

export default function productsDataConverter(products: Products) {
  return products.map((product: Products[number]) => {
    return {
      id: product.id,
      ticket: '',
      searchResultProduct: {
        ...product,
      },
    }
  })
}
